import { DateTime } from '@ksyos/date-time';
import { cloneDeep } from 'lodash';
import type { IServiceConsumer } from '../../components/interfaces/serviceConsumer';

export class ServiceConsumersFilter {
    private items: IServiceConsumer[];

    constructor(items: IServiceConsumer[]) {
        this.items = cloneDeep(items);
    }

    /**
     * Filters the array by a lower cased organization name
     * @param name The name of the organization
     */
    public filterByOrganizationName(name: string) {
        this.items = this.items.filter((serviceConsumer) =>
            serviceConsumer.employment.organization.name.toLowerCase().includes(name.toLowerCase())
        );

        return this;
    }

    public filterByOrganizationId(organizationId: string) {
        this.items = this.items.filter(
            (serviceConsumer) => serviceConsumer.employment.organization.id === organizationId
        );

        return this;
    }

    public filterByServiceId(serviceId: string) {
        this.items = this.items.filter((serviceConsumer) => serviceConsumer.service.id === serviceId);

        return this;
    }

    public filterByEmploymentId(employmentId: string) {
        this.items = this.items.filter((serviceConsumer) => serviceConsumer.employment.id === employmentId);

        return this;
    }

    public filterByPractitionerId(practitionerId: string) {
        this.items = this.items.filter(
            (serviceConsumer) => serviceConsumer.employment.practitioner.id === practitionerId
        );

        return this;
    }

    /**
     * Filters the array based on if the current date falls in the serviceConsumer & employment start- & enddate
     */
    public filterByActive() {
        const now = DateTime.now();
        this.items = this.items.filter((serviceConsumer) => {
            return (
                now.isBetween(serviceConsumer.startDate, serviceConsumer.endDate || '9999-12-31', null, '[]') &&
                now.isBetween(
                    serviceConsumer.employment.startDate,
                    serviceConsumer.employment.endDate || '9999-12-31',
                    null,
                    '[]'
                )
            );
        });

        return this;
    }

    public toArray() {
        return this.items;
    }
}
